import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GetRepairInvoiceTypesService } from './get-repair-invoice-types/get-repair-invoice-types.service';

@NgModule({
  imports: [CommonModule],
  providers: [GetRepairInvoiceTypesService],
})
export class RepairInvoiceTypesModule {}